import { render, staticRenderFns } from "./AdditionalInformationInput.vue?vue&type=template&id=5b123d8a&scoped=true"
import script from "./AdditionalInformationInput.vue?vue&type=script&lang=js"
export * from "./AdditionalInformationInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b123d8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b123d8a')) {
      api.createRecord('5b123d8a', component.options)
    } else {
      api.reload('5b123d8a', component.options)
    }
    module.hot.accept("./AdditionalInformationInput.vue?vue&type=template&id=5b123d8a&scoped=true", function () {
      api.rerender('5b123d8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/partials/AdditionalInformationInput.vue"
export default component.exports